export const PAYMENT_TYPE = {
    CASH_PAYMENT: 'Cash',
    CHEQUE_PAYMENT :'Cheque',
    OVER_PAYMENT :'Over Payment',
    RETURN_AMOUNT :'Return Amount',
    ROYALTY_POINTS:'Royalty Points',
    PARTLY_PAID:1,
    FULLY_PAID: 2,
   
}